module.exports = __webpack_public_path__ + "img/recruit_container.05892e32.png";